import Env from '../base/env.js';
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import Sms from '../modules/civilisation/Sms'
import DatesCount from '../modules/civilisation/DatesCount'
import WineWords from '../modules/civilisation/WineWords'


const fns = {
  Sms : Sms,
  DatesCount: DatesCount,
  WineWords:WineWords
}

export default class RevealFx
{
  constructor(view)
  {
    this.view = view
    this.$reveals = this.view.querySelectorAll('.jsReveal')
    this.animation()
  }

  animation()
  {
    for(let $reveal of this.$reveals) {
      const offset = $reveal.getAttribute('data-offset')
      const st = ScrollTrigger.create({
        trigger: $reveal,
        markers: false,
        start: `top ${offset}%`,
        once: Env.scrollTrigger.once,
        onEnter:()=>{
          $reveal.classList.add('is-revealed')
          if($reveal.getAttribute('data-init') != null) {
            const fn = $reveal.getAttribute('data-init')
            const callClass = fns[fn]
            new callClass($reveal)
          }
        }
      })
    }
  }
}
